import { setFeatureTableOpen_actionType } from "../constants";

export const setFeatureTableOpen = (isOpen) => ({
  type: setFeatureTableOpen_actionType,
  payload: isOpen,
});
